import { render, staticRenderFns } from "./NotificationIncidentDetails.vue?vue&type=template&id=0d37cd32&"
import script from "./NotificationIncidentDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationIncidentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports